import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Avatar } from '@mui/material';
// routes
import { PATH_AUTH, PROFILE_DETAIL } from '../../../routes/paths';
// auth
import MenuPopover from '../../../components/menu-popover';
import { IconButtonAnimate } from '../../../components/animate';

import { CustomAvatar } from '../../../components/custom-avatar';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../../store/authenticationSlice';
import { RootState } from '../../../store';
import { IMAGE_MERCHANT_ROOT_URL } from '../../../constants/imageUrl';

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation("global");
  const authData = useSelector((state: RootState) => state?.auth?.data || null!);

  const [openPopover, setOpenPopover] = useState<HTMLElement | null>(null);

  const handleOpenPopover = (event: React.MouseEvent<HTMLElement>) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  const handleLogout = async () => {
    try {
      navigate(PATH_AUTH.login, { replace: true });
      handleClosePopover();
      dispatch(logout());
    } catch (error) {
      console.error(error);
    }
  };

  const handleOpenDetail = () => {
    navigate(PROFILE_DETAIL)
  }

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpenPopover}
        sx={{
          p: 0,
          ...(openPopover && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar src={IMAGE_MERCHANT_ROOT_URL + authData?.profile?.image?.url} alt={authData?.username} />
      </IconButtonAnimate>

      <MenuPopover open={openPopover} onClose={handleClosePopover} sx={{ width: 200, p: 0 }}>
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {authData?.username}
          </Typography>

          <Typography variant="body2" sx={{ color: 'text.secondary', height: 20 }} noWrap>
            {authData?.profile?.firstname}  {authData?.profile?.lastname}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        {/* <Stack sx={{ p: 1 }}>
          <MenuItem onClick={() => {
            handleClosePopover();
            navigate('/changePassword');
          }}>
            {t('Change password')}
          </MenuItem>
        </Stack> */}
        <Divider sx={{ borderStyle: 'dashed' }} />
        <MenuItem sx={{ m: 1 }} onClick={handleOpenDetail}>
          {t('Detail')}
        </MenuItem>
        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
          {t('navbar_component.Logout')}
        </MenuItem>
      </MenuPopover>
    </>
  );
}
